import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import * as builder from "../../ducks/builder";
import Brand from "../brand/Brand";
import PerfectScrollbar from "react-perfect-scrollbar";
import Menu from "./Menu";
import KTOffcanvas from "../../_assets/js/offcanvas";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
import HtmlClassService from "../HTMLClassService";

const htmlClassService = new HtmlClassService();

function AsideLeft({
  disableAsideSelfDisplay,
  disableScroll,
  asideClassesFromConfig,
  menuCanvasOptions,
}) {
  const asideOffCanvasRef = useRef(null);
  const { userPreferences, reload } = useGlobalData();

  useEffect(() => {
    // eslint-disable-next-line
    const ktoffConvas = new KTOffcanvas(
      asideOffCanvasRef.current,
      menuCanvasOptions
    );
  }, [reload]);

  return (
    <>
      <button className="kt-aside-close" id="kt_aside_close_btn">
        <i className="la la-close" />
      </button>
      <div
        id="kt_aside"
        ref={asideOffCanvasRef}
        className={`kt-aside ${asideClassesFromConfig} kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop${
          userPreferences.lightAsideSkin === true
            ? " kt-aside-light"
            : " kt-aside-dark"
        }`}
        style={{
          backgroundColor: `${
            userPreferences.lightAsideSkin === true ? `#ffffff` : `#1e1e2d`
          }`,
        }}
      >
        <Brand />
        <div
          id="kt_aside_menu_wrapper"
          className="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid"
        >
          {disableScroll && <Menu htmlClassService={htmlClassService} />}
          {!disableScroll && (
            <PerfectScrollbar
              style={{ height: "90%" }}
              options={{ wheelSpeed: 2, wheelPropagation: false }}
            >
              <Menu htmlClassService={htmlClassService} />
            </PerfectScrollbar>
          )}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (store) => ({
  disableAsideSelfDisplay:
    builder.selectors.getConfig(store, "aside.self.display") === false,
  disableScroll:
    builder.selectors.getConfig(store, "aside.menu.dropdown") === "true" ||
    false,
  asideClassesFromConfig: builder.selectors.getClasses(store, {
    path: "aside",
    toString: true,
  }),
  menuCanvasOptions: {
    baseClass: "kt-aside",
    overlay: true,
    closeBy: "kt_aside_close_btn",
    toggleBy: {
      target: "kt_aside_mobile_toggler",
      state: "kt-header-mobile__toolbar-toggler--active",
    },
  },
});

export default connect(mapStateToProps)(AsideLeft);
